import { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { DEFAULT_LANGUAGE } from "Website/Language/constants";
import i18n from "features/Languages/i18n";
import { getSelectedLang } from "Website/Language/helpers";
import { useLocation } from "react-router-dom";
import { isHelpPage } from "Website/Pages/Help/helpers";
import { isPolicyPage } from "Website/Pages/Policy/helper";
import { useTranslation } from "react-i18next";

const APP_DOWNLOAD_PATH = '/app-download';

const Layout = ({ children, setBasename, basename }) => {
    const { i18n } = useTranslation();
    const selectedLang = getSelectedLang(i18n.language);
    const location = useLocation();
    const helpPage = isHelpPage(location.pathname);
    const policyPage = isPolicyPage(location.pathname);
    const appDownloadPage = location.pathname === APP_DOWNLOAD_PATH;

    const handleSetLanguage = (newLang) => {
        const currentPath = window.location.pathname;
        let pathWithoutPrefix = currentPath;

        // Remove existing language prefix if any based on current basename
        if (basename === '/fr') {
            pathWithoutPrefix = currentPath.substring(3);
            if (pathWithoutPrefix === '') pathWithoutPrefix = '/';
        }

        // Add the newly selected language prefix only if it is French
        const newPath = newLang === 'fr' ? `/fr${pathWithoutPrefix === '/' ? '' : pathWithoutPrefix}` : pathWithoutPrefix;

        if (currentPath !== newPath) {
            // Set localStorage for the language
            localStorage.setItem('i18nextLng', newLang);

            // Push state instead of reloading
            window.history.pushState(null, '', newPath);

            // Sync i18n BEFORE remounting
            i18n.changeLanguage(newLang).then(() => {
                // Update basename state, which unmounts and remounts <Router> and <Layout>
                // This triggers a fast React re-render instead of a full browser reload
                if (setBasename) setBasename(newLang === 'fr' ? '/fr' : '');
            });
        }
    }

    if (appDownloadPage) {
        return <>{children}</>;
    }

    return (
        <>
            <Header handleSetLanguage={handleSetLanguage} selectedLang={selectedLang} />
            <div className={`content_section ${helpPage || policyPage ? 'help_page' : ''} ${(location.pathname === '/about') ? 'about-layout' : ''}`}>
                {children}
            </div>
            {!helpPage && !policyPage && <Footer handleSetLanguage={handleSetLanguage} selectedLang={selectedLang} />}
        </>
    )
}

export default Layout;